export enum KnmResultInfoTypeCodesEnum {
  ACT_WAS_NOT_READ_NOTE = 'ACT_WAS_NOT_READ_NOTE',
  WRONG_DATA_REASON_SEC_I = 'WRONG_DATA_REASON_SEC_I',
  ABSENT_VIOLATION_NOTE = 'ABSENT_VIOLATION_NOTE',
  UNIMPOSSIBLE_REASON_I = 'UNIMPOSSIBLE_REASON_I',
  UNDOIG_SEC_I = 'UNDOIG_SEC_I',
  PURCHASE_GOODS_FOR_RESEARCH = 'PURCHASE_GOODS_FOR_RESEARCH',
  PURCHASE_RESULT_OF_RESEARCH = 'PURCHASE_RESULT_OF_RESEARCH',
}
